var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6.25H8.75C8.08696 6.25 7.45107 6.51339 6.98223 6.98223C6.51339 7.45107 6.25 8.08696 6.25 8.75V23.75C6.25 24.413 6.51339 25.0489 6.98223 25.5178C7.45107 25.9866 8.08696 26.25 8.75 26.25H21.25C21.913 26.25 22.5489 25.9866 23.0178 25.5178C23.4866 25.0489 23.75 24.413 23.75 23.75V8.75C23.75 8.08696 23.4866 7.45107 23.0178 6.98223C22.5489 6.51339 21.913 6.25 21.25 6.25H18.75M11.25 6.25C11.25 5.58696 11.5134 4.95107 11.9822 4.48223C12.4511 4.01339 13.087 3.75 13.75 3.75H16.25C16.913 3.75 17.5489 4.01339 18.0178 4.48223C18.4866 4.95107 18.75 5.58696 18.75 6.25M11.25 6.25C11.25 6.91304 11.5134 7.54893 11.9822 8.01777C12.4511 8.48661 13.087 8.75 13.75 8.75H16.25C16.913 8.75 17.5489 8.48661 18.0178 8.01777C18.4866 7.54893 18.75 6.91304 18.75 6.25M17.5 13.75H14.375C13.8777 13.75 13.4008 13.9475 13.0492 14.2992C12.6975 14.6508 12.5 15.1277 12.5 15.625C12.5 16.1223 12.6975 16.5992 13.0492 16.9508C13.4008 17.3025 13.8777 17.5 14.375 17.5H15.625C16.1223 17.5 16.5992 17.6975 16.9508 18.0492C17.3025 18.4008 17.5 18.8777 17.5 19.375C17.5 19.8723 17.3025 20.3492 16.9508 20.7008C16.5992 21.0525 16.1223 21.25 15.625 21.25H12.5M15 21.25V22.5M15 12.5V13.75",
    stroke: "#3C3C3C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.2f337b67fe38e6a5e3d582ed7fb5d73a.svg";
export { ForwardRef as ReactComponent };